import styled from 'styled-components'

export const TextLinkImageComponent = styled.div`
  margin: 0 -15px 25px;

  @media ${ (props) => props.theme.breakpoints.devices.min.sm } {
    margin-bottom: 30px;
  }

  .cookieHeader {
    position: relative;
    padding: 10px 20px;
    width: 100%;
    background: ${ (props) => props.theme.colors.hellgruen1 };
    color: ${ (props) => props.theme.colors.weiss };
    text-align: center;
    margin-bottom: 30px;

    * strong {
      text-decoration: underline;
    }
  }

  .cookieHeader::after {
    content: '';
    position: absolute;
    left: 42%;
    top: 100%;
    width: 0;
    height: 0;
    border-left: 20px solid transparent;
    border-right: 20px solid transparent;
    border-top: 20px solid ${ (props) => props.theme.colors.hellgruen1 };
    clear: both;
  }

  .image {
    width: 100%;
    margin-top: 20px;

    @media ${ (props) => props.theme.breakpoints.devices.min.sm } {
      margin-top: 0px;
    }
  }

  .more-link {
    display: inline-block;
  }
`
